import React, { ReactElement, ReactNode } from "react";
import { NavLink, useLocation } from "react-router";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import { ListItemIcon, ListItemText } from "@mui/material";
import { useHasPermission } from "@/hooks";
import { isLocationActive } from "@/common/Methods";
import { alpha } from "@mui/material/styles";

interface Level1MenuItemProps {
  link: string;
  label: string;
  feature: string;
  icon: ReactNode;
  codes: string[];
  hide?: boolean;
}

export const Level1MenuItem = ({
  link,
  label,
  icon,
  codes,
  feature,
  hide,
}: Level1MenuItemProps): ReactElement | null => {
  const location = useLocation();
  const { allow } = useHasPermission(codes, feature);

  const isActive = isLocationActive(location, link);
  const activeColor = isActive
    ? "leftMenu.textColorActive"
    : "leftMenu.textColorInActive";

  if (!allow || hide) {
    return null;
  }

  return (
    <NavLink
      to={link}
      style={{
        textDecoration: "none",
      }}
    >
      <ListItem
        disablePadding
        sx={{
          color: activeColor,
        }}
      >
        <ListItemButton
          disableGutters
          sx={(theme) => ({
            p: 1,
            borderRadius: "8px",
            backgroundColor: isActive
              ? alpha(theme.palette.leftMenu.backgroundColorSelected, 0.28)
              : "transparent",
          })}
        >
          <ListItemIcon
            sx={{
              minWidth: "25px",
              color: activeColor,
            }}
          >
            {icon}
          </ListItemIcon>
          <ListItemText primary={label} />
        </ListItemButton>
      </ListItem>
    </NavLink>
  );
};
